function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React from "react";
// import SearchBar from "../../../Common/SearchBar";
import { useData } from "./data";
// import { arrowSvg, coinSvg, giftHandSvg, giftSvg, moneyBagSvg } from "./svg";
// import { toIndianRs, toNumberFormat } from "../../../../helpers";
// import TiTick from "@meronex/icons/ti/TiTick";
// import BundleOffers from "../BundleOffers";
// import BsInfoCircle from "@meronex/icons/bs/BsInfoCircle";
import { useState } from "react";
// import Modal from "../../../../Components/Organisms/Modal";
// import ReactPlayer from "react-player";
// import VideoModal from "../../../../Components/Organisms/VideoModal";
import { isReloy } from "../../../../utils/isClient";
import { DealsHeaderLayout } from "./Components/DealsHeaderLayout";
import { BundleHeaderLayout } from "./Components/BundleHeaderLayout";
import { RewardsHeaderLayout } from "./Components/RewardsHeaderLayout";
import { jsx as _jsx } from "react/jsx-runtime";
function Header(_ref) {
  var searchValue = _ref.searchValue,
    onSearchChange = _ref.onSearchChange,
    internalWebview = _ref.internalWebview,
    isRewards = _ref.isRewards,
    userAccountSummary = _ref.userAccountSummary,
    claimNowHandler = _ref.claimNowHandler,
    kycStatus = _ref.kycStatus,
    isBundeOffers = _ref.isBundeOffers,
    config = _ref.config,
    appType = _ref.appType,
    _ref$redux = _ref.redux,
    redux = _ref$redux === void 0 ? {} : _ref$redux,
    _ref$router = _ref.router,
    router = _ref$router === void 0 ? {} : _ref$router,
    winnreAuth = _ref.winnreAuth,
    isPoints = _ref.isPoints;
  var isAuthenticated = redux === null || redux === void 0 ? void 0 : redux.isAuthenticated;
  var _useData = useData({
      winnreAuth: winnreAuth
    }),
    cashback = _useData.cashback;
  var kycNotCompleted = kycStatus == "NOT_INITIATED" || kycStatus == "INITIATED" || kycStatus == "null" || kycStatus == "FAILED" || kycStatus == "PROCESSING";
  var kycCompleted = kycStatus == "COMPLETED";
  // const internalWebview = useSelector(
  //     (state) => state.webView.internalWebview
  // );
  var isSpecialConfig = config.id === 19 || config.id === 14;
  var backgroundClass = isSpecialConfig ? "bg-[#EDEEF0]" : "bg-primary";
  var textColorClass = isSpecialConfig ? "text-black" : "text-white";
  var buttonBg = isSpecialConfig ? "bg-[#46434333]" : "bg-[#FFFFFF33]";
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    playKYCVideo = _useState2[0],
    setPlayKYCVideo = _useState2[1];
  var isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
  var variant = isBundeOffers ? "bundle" : isRewards ? "rewards" : "deals";
  // console.log(
  //     'kyc completed',
  //     kycCompleted,
  //     'kycNotCompleted',
  //     kycNotCompleted
  // );
  var history = (router === null || router === void 0 ? void 0 : router.history) || {
    push: function push() {},
    replace: function replace() {}
  };
  var dispatch = redux === null || redux === void 0 ? void 0 : redux.dispatch;
  var authActions = redux === null || redux === void 0 ? void 0 : redux.authActions;
  var handleRewardClick = function handleRewardClick() {
    if (isReloy(config)) {
      return;
    }
    if (isAuthenticated) {
      history.push("/myprofile/rewards");
    } else {
      history.push("/deals?postLoginUrl=myprofile/rewards");
      if (dispatch && authActions !== null && authActions !== void 0 && authActions.openLoginModal) {
        dispatch(authActions.openLoginModal());
      }
    }
  };
  var totalPoints = isPoints ? Number((userAccountSummary === null || userAccountSummary === void 0 ? void 0 : userAccountSummary.reloyRewardPoints) || 0) : Number((userAccountSummary === null || userAccountSummary === void 0 ? void 0 : userAccountSummary.unInvoicedCommission) + (userAccountSummary === null || userAccountSummary === void 0 ? void 0 : userAccountSummary.rewardPoints));
  var claimCTA = function claimCTA() {
    if (totalPoints <= 0) {
      var _window;
      if (appType === "winnre" || isPoints) {
        return; // Hide referral action for winnre
      }
      (_window = window) === null || _window === void 0 || (_window = _window.webengage) === null || _window === void 0 || _window.track("ReferralSection", {
        From: "Rewards"
      });
      if (internalWebview && isIOS) {
        var _window2;
        var valueToSend = {
          type: "OPEN_REFERRAL_IN_BROWSER"
        };
        (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.webkit) === null || _window2 === void 0 || (_window2 = _window2.messageHandlers) === null || _window2 === void 0 || _window2.jsMessageHandler.postMessage(valueToSend);
      } else {
        history.push("/gift-and-earn");
      }
      return;
    }
    claimNowHandler(false, true, false);
  };
  var handleRedeemClick = function handleRedeemClick() {
    history.push(isPoints ? "/rewardPointStore" : "/rewardStore", {
      scrollTo: "rewards"
    });
  };
  if (variant === "rewards") {
    return /*#__PURE__*/_jsx(RewardsHeaderLayout, {
      searchValue: searchValue,
      onSearchChange: onSearchChange,
      internalWebview: internalWebview,
      userAccountSummary: userAccountSummary,
      kycStatus: kycStatus,
      config: config,
      isAuthenticated: isAuthenticated,
      backgroundClass: backgroundClass,
      textColorClass: textColorClass,
      buttonBg: buttonBg,
      totalPoints: totalPoints,
      kycCompleted: kycCompleted,
      kycNotCompleted: kycNotCompleted,
      playKYCVideo: playKYCVideo,
      setPlayKYCVideo: setPlayKYCVideo,
      claimCTA: claimCTA,
      handleRedeemClick: handleRedeemClick,
      appType: appType,
      redux: redux,
      isPoints: isPoints,
      history: history
    });
  }
  if (variant === "bundle") {
    return /*#__PURE__*/_jsx(BundleHeaderLayout, {
      searchValue: searchValue,
      onSearchChange: onSearchChange,
      internalWebview: internalWebview,
      config: config,
      isBundeOffers: isBundeOffers,
      redux: redux,
      router: router
    });
  }

  // default: deals
  return /*#__PURE__*/_jsx(DealsHeaderLayout, {
    searchValue: searchValue,
    onSearchChange: onSearchChange,
    internalWebview: internalWebview,
    config: config,
    cashback: cashback,
    isAuthenticated: isAuthenticated,
    appType: appType,
    redux: redux,
    router: router
  });

  // return (
  //     <div className="flex flex-col lg:flex-row text-white gap-x-5 cursor-pointer">
  //         <div
  //             className={` ${
  //                 isBundeOffers
  //                     ? 'w-full '
  //                     : 'w-full lg:w-[80%] xl:w-[75%] 2xl:w-[80%]'
  //             } ${
  //                 internalWebview ? 'sticky top-0 z-10 bg-white py-1 ' : ''
  //             } `}
  //         >
  //             {!isRewards && (
  //                 <div
  //                     className={`${
  //                         internalWebview
  //                             ? 'fixed top-0 z-10 w-[95%]  lg:w-[70%] pt-4 pb-1 bg-white'
  //                             : ''
  //                     }`}
  //                 >
  //                     <SearchBar
  //                         searchValue={searchValue}
  //                         onSearchChange={onSearchChange}
  //                         // navigateOnClick
  //                     />
  //                 </div>
  //             )}

  //             {
  //                 <div
  //                     className={`hidden lg:block w-full h-full ${
  //                         internalWebview ? 'mt-16' : ''
  //                     } ${isRewards ? '' : 'mt-4'}`}
  //                 >
  //                     {!isBundeOffers && (
  //                         <img
  //                             className="w-full h-full md:h-auto object-cover rounded-xl cursor-default"
  //                             src={
  //                                 isRewards
  //                                     ? config?.deals?.rewardsBanner
  //                                           ?.backgroundImage
  //                                         ? config?.deals?.rewardsBanner
  //                                               ?.backgroundImage
  //                                         : 'https://cdn.loyalie.in/1727098888354_reward%20banner%20web'
  //                                     : isReloy
  //                                     ? 'https://cdn.loyalie.in/1752570891334_THT_OFFERS'
  //                                     : 'https://cdn.loyalie.in/1717359717328_deal%20new%20main%20banner'
  //                             }
  //                         />
  //                     )}
  //                     {isBundeOffers &&
  //                         config?.clientId ==
  //                             '4757d92ecbc85bd93320870e1d15ae79788920c0cbf41abe884bfbc4980a0c08' && (
  //                             <img
  //                                 className="w-full h-full md:h-auto object-cover rounded-xl"
  //                                 src={
  //                                     'https://cdn.loyalie.in/1729488243491_godrej-welcomegift-banner'
  //                                 }
  //                             />
  //                         )}
  //                 </div>
  //             }

  //             {isRewards && (
  //                 <div className={`lg:hidden w-full h-full`}>
  //                     <img
  //                         className="w-full h-full md:w-auto md:h-auto object-cover rounded-xl"
  //                         src={
  //                             config?.deals?.rewardsBanner
  //                                 ?.backgroundImageMobile
  //                                 ? config?.deals?.rewardsBanner
  //                                       ?.backgroundImageMobile
  //                                 : 'https://cdn.loyalie.in/1727430271982_rewardStoreMob'
  //                         }
  //                     />
  //                 </div>
  //             )}
  //         </div>
  //         {!isBundeOffers && (
  //             <div
  //                 className={`flex flex-col w-full lg:w-[30%] xl:w-[25%] 2xl:w-[24%] px-5 py-10 lg:py-5 xl:py-10 rounded-xl ${
  //                     internalWebview ? 'mt-14' : 'mt-4 lg:mt-0'
  //                 } ${
  //                     isRewards
  //                         ? `justify-between ${backgroundClass}`
  //                         : 'bg-primary'
  //                 }`}
  //             >
  //                 {isRewards && (
  //                     <>

  //                         <div
  //                             onClick={() =>
  //                                 !isAuthenticated
  //                                     ? dispatch(authActions.openLoginModal())
  //                                     : null
  //                             }
  //                             className="flex flex-col"
  //                         >
  //                             <div className=" mt-2">
  //                                 {kycCompleted && isAuthenticated && (
  //                                     <div className={`${textColorClass}`}>
  //                                         <p className="ml-2">
  //                                             ✅ KYC Completed
  //                                             {totalPoints > 0
  //                                                 ? ' – You’re ready to redeem your rewards!'
  //                                                 : ''}
  //                                         </p>
  //                                     </div>
  //                                 )}

  //                                 {!kycCompleted &&
  //                                     isAuthenticated &&
  //                                     totalPoints > 0 && (
  //                                         <div
  //                                             className={`${textColorClass}`}
  //                                         >
  //                                             <p className="ml-2">
  //                                                 {kycStatus ===
  //                                                 'PROCESSING' ? (
  //                                                     <>
  //                                                         ⏳ KYC under
  //                                                         process.
  //                                                     </>
  //                                                 ) : (
  //                                                     <>
  //                                                         <div className="flex justify-end -mt-3 xl:-mt-5 mb-3 mr-2">
  //                                                             <BsInfoCircle
  //                                                                 onClick={() =>
  //                                                                     setPlayKYCVideo(
  //                                                                         true
  //                                                                     )
  //                                                                 }
  //                                                                 className="cursor-pointer w-4 h-4 text-white font-bold"
  //                                                             />
  //                                                         </div>
  //                                                         <span>
  //                                                             🚫 KYC Pending –
  //                                                             Complete your
  //                                                             verification to
  //                                                             redeem your
  //                                                             rewards.​
  //                                                         </span>

  //                                                     </>
  //                                                 )}
  //                                             </p>
  //                                         </div>
  //                                     )}
  //                             </div>

  //                             <div
  //                                 className={`flex flex-col  items-start w-full mt-6 `}
  //                             >
  //                                 <div className="flex  items-center gap-1">
  //                                     <div>{giftSvg}</div>
  //                                     <div className="">
  //                                         <p
  //                                             className={`lg:text-sm xl:text-base ml-2 ${textColorClass}`}
  //                                         >
  //                                             {isAuthenticated
  //                                                 ? totalPoints <= 0
  //                                                     ? userAccountSummary?.claimedRewardPoints >
  //                                                       0
  //                                                         ? 'You have claimed your rewards. Refer now to earn more rewards!'
  //                                                         : "You don't have Rewards to claim"
  //                                                     : 'You have rewards waiting for you'
  //                                                 : 'Login to check Rewards eligibility'}
  //                                         </p>
  //                                     </div>
  //                                 </div>

  //                                 {!isAuthenticated && (
  //                                     <button
  //                                         onClick={() =>
  //                                             dispatch(
  //                                                 authActions.openLoginModal()
  //                                             )
  //                                         }
  //                                         className={`mt-4 lg:mt-5 xl:mt-8  py-2  px-10 rounded  ${buttonBg} ${textColorClass} font-bold ml-1`}
  //                                     >
  //                                         Login
  //                                     </button>
  //                                 )}

  //                                 {isAuthenticated && (
  //                                     <button
  //                                         onClick={
  //                                             totalPoints > 0 && kycCompleted
  //                                                 ? handleRedeemClick
  //                                                 : claimCTA
  //                                         }
  //                                         className={`mt-4 lg:mt-5 xl:mt-8 py-2 px-8 rounded ${buttonBg} ${textColorClass} font-bold ml-1`}
  //                                     >
  //                                         {totalPoints > 0 && kycCompleted
  //                                             ? 'Redeem Now'
  //                                             : totalPoints <= 0
  //                                             ? 'Refer Now'
  //                                             : 'COMPLETE KYC​'}
  //                                     </button>
  //                                 )}
  //                             </div>
  //                         </div>

  //                     </>
  //                 )}
  //                 {!isRewards && (
  //                     <div onClick={handleRewardClick}>
  //                         {cashback ? (
  //                             <div className="flex flex-row md:flex-col justify-start md:justify-center items-center lg:items-start pb-5">
  //                                 {coinSvg}
  //                                 <div className="ml-4 md:ml-0">
  //                                     <h1 className="text-2xl font-semibold mt-0 lg:mt-6">
  //                                         {toIndianRs(cashback)}
  //                                     </h1>
  //                                     <h3 className="text-lg font-semibold mt-0 lg:mt-3">
  //                                         Total Cashback
  //                                     </h3>
  //                                 </div>
  //                             </div>
  //                         ) : (
  //                             <div className="flex flex-row md:flex-col md:justify-center items-center pb-5">
  //                                 {isReloy ? (
  //                                     <img
  //                                         src="https://cdn.loyalie.in/1752571193146_WHITE_GIFT"
  //                                         alt=""
  //                                         className="h-24 w-24"
  //                                     />
  //                                 ) : (
  //                                     moneyBagSvg
  //                                 )}

  //                                 <div className="ml-4 md:ml-0">
  //                                     {config?.deals?.dealsSection
  //                                         ?.referralText ? (
  //                                         <div>
  //                                             {
  //                                                 config?.deals?.dealsSection
  //                                                     ?.referralText
  //                                             }
  //                                         </div>
  //                                     ) : (
  //                                         <div>
  //                                             <p>
  //                                                 {isReloy
  //                                                     ? ''
  //                                                     : 'Refer a friend or share our '}
  //                                             </p>
  //                                             <p>
  //                                                 {isReloy
  //                                                     ? ''
  //                                                     : 'deals to earn a scratch card!'}
  //                                             </p>
  //                                         </div>
  //                                     )}
  //                                 </div>
  //                             </div>
  //                         )}
  //                         <div
  //                             onClick={() => {
  //                                 if (isReloy) {
  //                                     return;
  //                                 }
  //                                 history.push('/myprofile/rewards');
  //                             }}
  //                             className="flex justify-between items-center cursor-pointer border-t-[2px] border-[#FFFFFF33] pt-5 gap-x-3"
  //                         >
  //                             <div>
  //                                 <p
  //                                     className={`"font-medium ${
  //                                         isReloy
  //                                             ? 'text-lg md:text-xl'
  //                                             : 'text-base md:text-sm'
  //                                     }`}
  //                                 >
  //                                     {isReloy
  //                                         ? 'Great experiences deserve exceptional rewards.'
  //                                         : 'Scratch and win exciting rewards!'}
  //                                 </p>
  //                                 <p
  //                                     className={` ${
  //                                         isReloy
  //                                             ? 'text-base mt-4'
  //                                             : 'text-xs mt-2'
  //                                     }`}
  //                                 >
  //                                     {isReloy
  //                                         ? 'Explore handpicked offers curated to make your journey more meaningful and more memorable. Because when you choose the best, every detail should feel rewarding.'
  //                                         : 'Check your ongoing rewards and scratch to reveal your prizes.'}
  //                                 </p>
  //                             </div>
  //                             {!isReloy && arrowSvg}
  //                         </div>
  //                     </div>
  //                 )}
  //             </div>
  //         )}
  //         <VideoModal
  //             isVisible={playKYCVideo}
  //             setIsVisible={setPlayKYCVideo}
  //             videoUrl="https://www.youtube.com/shorts/yGU-AIZlxw8"
  //         />
  //     </div>
  // );
}
export default Header;